import React from "react";
import { Typography } from "@mui/material";
import { Trans } from "react-i18next";

const IltVersionInstructorTooltipContent = () => {
  return (
    <Typography variant="body2" color="textSecondary">
      <Trans i18nKey="components.tooltip.IltVersionInstructorTooltipContent.IltVersionInstructorMessage">
        You cannot select this session because you are the instructor.
      </Trans>
    </Typography>
  );
};

export default IltVersionInstructorTooltipContent;
